import type { IBusiness } from "@/business/business";
import {
  hasFullWorkbookAuthority,
  type WorkbookAuthorityUser,
} from "@/payroll/pay-breakdown/workbook-authority";

/**
 * Whether this user may ask a workbook's approvers to sign off. Mirrors the two
 * gates the API enforces, so someone who could only ever get a 403 never sees
 * the button:
 *
 * - finance access (`can_manage_finances?`), and
 * - authority over the WHOLE workbook.
 *
 * The second is the one that is easy to get wrong. Asking speaks for the payroll
 * as a whole ("your sheets are ready to sign off"), is recorded once per pay
 * period rather than per department, and lands in the inbox of people a
 * department lead has no authority over — so narrowing the ask to the units a
 * lead can see is not a substitute for withholding it.
 *
 * The predicate itself lives in `../workbook-authority`, shared with the other
 * whole-workbook surfaces (see `hasFullWorkbookAuthority`).
 */
export const canRequestSheetApprovals = (
  business: IBusiness | null | undefined,
  user: WorkbookAuthorityUser | null | undefined,
) => hasFullWorkbookAuthority(business, user);
